module.exports = __webpack_public_path__ + "img/80-X-Brush Titan - Gris Métal Clair.jpg";